module.exports = __webpack_public_path__ + "static/media/up-arrow.58101827.svg";